<template>
  <div id="join-in-new">
    <el-dialog custom-class="join-in-modal"
               :visible.sync="centerDialogVisible"
               :close-on-click-modal="false"
               center
               append-to-body>
      <span slot="title"
            class="dialog-title">填写报名信息</span>
      <div class="modal-container">
        <el-form :model="registerInfo"
                 :rules="rules"
                 ref="ruleForm">
          <el-form-item prop="phone">
            <div class="info">
              <div class="title">
                手机号码
                <span>若要更换手机号，请先退出登录</span>
              </div>
              <div class="input">
                <el-input v-model="registerInfo.phone"
                          disabled></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="name">
            <div class="info">
              <div class="title">学生姓名</div>
              <div class="input">
                <el-input v-model="registerInfo.name"
                          placeholder="请输入学生姓名"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="parentphone">
            <div class="info">
              <div class="title">家长电话</div>
              <div class="input">
                <el-input v-model="registerInfo.parentphone"
                          placeholder="请输入家长电话"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="info">
              <div class="title">所在中学</div>
              <div class="input flex-center">
                <el-form-item class="el-col-12"
                              style="padding-right: 12px">
                  <el-cascader v-model="cascadeData"
                               class="cascade"
                               :props="cascadeProps"
                               placeholder="省/市/县"
                               clearable
                               @change="initSchool"></el-cascader>
                </el-form-item>
                <el-form-item prop="schoolName"
                              class="el-col-12">
                  <el-autocomplete class="inline-input"
                                   v-model="registerInfo.schoolName"
                                   :fetch-suggestions="querySearch"
                                   placeholder="手动输入所在中学"
                                   @select="handleSelect">
                    <template slot-scope="{ item }">
                      <div class="school-name">{{ item.school_name }}</div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="grade">
            <div class="info">
              <div class="title">学生年级</div>
              <div class="input">
                <el-select v-model="registerInfo.grade"
                           placeholder="请选择">
                  <el-option v-for="item in gradeList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="info">
          <div class="input">
            <el-checkbox v-model="checked">我已同意</el-checkbox>
            <span class="protocol hand"
                  @click="showAgreement">《质心灵动量入学协议书》</span>
            <p class="tips">报名前请务必阅读本协议</p>
          </div>
        </div>
        <div class="button-area flex-center hand">
          <el-button class="submit flex-center"
                     type="primary"
                     @click="submitForm('ruleForm')"
                     :disabled="!checked">提交
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-drawer title="填写报名信息"
               :visible.sync="drawer"
               @opened="openedDrawer"
               @open="openedDrawer"
               size="auto"
               :with-header="false"
               direction="btt">
      <div class="modal-container"
           style="width:90%;margin:0 auto;padding-bottom: 10px;color:#333;margin-top: 10px;">
        <el-form :model="registerInfo"
                 :rules="rules"
                 ref="ruleForm"
                 size="small">
          <el-form-item prop="phone">
            <div class="info">
              <div class="title">手机号码
                <span style=" font-size: 12px; margin-left: 12px; color: #33333360;">
                  若要更换手机号，请先退出登录
                </span>
              </div>
              <div class="input">
                <el-input v-model="registerInfo.phone"
                          disabled></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="name">
            <div class="info">
              <div class="title">学生姓名</div>
              <div class="input">
                <el-input v-model="registerInfo.name"
                          placeholder="请输入学生姓名"
                          :autofocus="false"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="parentphone">
            <div class="info">
              <div class="title">家长电话</div>
              <div class="input">
                <el-input v-model="registerInfo.parentphone"
                          placeholder="请输入家长电话"
                          :autofocus="false"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="schoolName">
            <div class="info">
              <div class="title">所在中学</div>
              <div class="input">
                <el-input placeholder="手动输入所在中学"
                          v-model="registerInfo.schoolName"
                          class="default-input">
                  <el-button slot="append"
                             type="primary"
                             @click="openSchoolDrawer">选择学校</el-button>
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="grade">
            <div class="info">
              <div class="title">学生年级</div>
              <div class="input">
                <el-select v-model="registerInfo.grade"
                           placeholder="请选择">
                  <el-option v-for="item in gradeList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="info">
          <div class="input">
            <el-checkbox v-model="checked">我已同意</el-checkbox>
            <span class="protocol hand"
                  @click="showAgreement">《质心灵动量入学协议书》</span>
            <p class="tips">报名前请务必阅读本协议</p>
          </div>
        </div>
        <div class="button-area flex-center hand">
          <el-button class="submit flex-center"
                     type="primary"
                     @click="submitForm('ruleForm')"
                     :disabled="!checked">提交
          </el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="请选择所在中学"
               :visible.sync="drawerSchool"
               size="auto"
               direction="btt">
      <div class="modal-container">
        <h5 class="text-center">如无法查询您所在学校请手动输入</h5>
        <el-tabs class="joinuptabs"
                 v-model="activeName"
                 :before-leave="beforeLeave">
          <el-tab-pane label="省份"
                       name="0">
            <ul v-for="item in provinceList"
                :key="item.letter">
              <span>{{item.letter}}</span>
              <li v-for="name in item.data"
                  :class="{ active: provinceName === name }"
                  @click="nameClick(0, name)"
                  :key="name">{{name}}
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="城市"
                       name="1">
            <slot v-for="item in cityList">
              <ul :key="item.letter">
                <span>{{item.letter}}</span>
                <li v-for="name in item.data"
                    :class="{ active: cityName === name }"
                    @click="nameClick(1, name)"
                    :key="name">{{name}}
                </li>
              </ul>
            </slot>
            <span v-if="!cityList.length">请先选择省份</span>
          </el-tab-pane>
          <el-tab-pane label="区县"
                       name="2">
            <slot v-for="item in districtList">
              <ul :key="item.letter">
                <span>{{item.letter}}</span>
                <li v-for="name in item.data"
                    :class="{ active: districtName === name }"
                    @click="nameClick(2, name)"
                    :key="name">{{name}}
                </li>
              </ul>
            </slot>
            <span v-if="!districtList.length">请先选择城市</span>
          </el-tab-pane>
          <el-tab-pane label=""
                       name="3">
            <el-input v-model="filterSchool"
                      @input="filterSchoolName"
                      size="medium"
                      placeholder="输入学校名称过滤"></el-input>
            <ul v-for="item in tempSchoolList"
                :key="item.school_name">
              <li @click="nameClick(3, item.school_name)">{{item.school_name}}</li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-dialog title="提示"
               :visible.sync="unPayModalVisible"
               :close-on-click-modal="false"
               custom-class="msg-dialog"
               center>
      <span>该课程存在待支付订单，是否前往支付？</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="unPayModalVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="readToPay">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="createFailVisible"
               :close-on-click-modal="false"
               custom-class="msg-dialog"
               center
               @close="confirmMsg">
      <p class="text-center">{{msg}}</p>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="createFailVisible = false">好 的</el-button>
      </span>
    </el-dialog>
    <EntranceAgreement ref="EntranceAgreement" />
  </div>
</template>
<script>
import $ from 'jquery'
import api from '@/api'
import qs from 'qs'
import utils from '@/utils/utils'
import EntranceAgreement from '@/components/EntranceAgreement'
import { LOGIN_TYPE } from '@/utils/constants'
import { mapActions, mapState } from 'vuex'
import pinyin from 'pinyin'
import store from '@/store'
import router from '@/router'
import * as _ from 'underscore'
// import store from '@/store'
export default {
  name: 'JoinUpNow',
  props: {
    classInfo: {
      type: Object,
      default () {
        return { goods_id: 0, classId: 0 }
      }
    }
  },
  data: function () {
    return {
      // 提交订单 默认0为正常 1为团购
      activity_type: 0,
      centerDialogVisible: false,
      unPayModalVisible: false,
      createFailVisible: false,
      gradeList: [
        { label: '高一', value: 1 },
        { label: '高二', value: 2 },
        { label: '高三', value: 3 },
        { label: '初一', value: 4 },
        { label: '初二', value: 5 },
        { label: '初三', value: 6 },
        { label: '五年级', value: 7 },
        { label: '六年级', value: 8 }
      ],
      registerInfo: {
        name: null,
        phone: null,
        schoolName: null,
        grade: null,
        readProrocol: null,
        parentphone: null
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
          { max: 16, message: '最多输入16个字符', trigger: 'blur' }
        ],
        schoolName: [
          { required: true, message: '请输入所在中学', trigger: ['blur', 'change'] },
          { max: 128, message: '最多输入128个字符', trigger: ['blur', 'change'] }
        ],
        grade: [
          { required: true, message: '请选择年级', trigger: 'change' }
        ],
        parentphone: [
          { required: true, message: '请输入家长电话', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      checked: false,
      value: '',
      cascadeProps: {
        lazy: true,
        lazyLoad: this.initProvince
      },
      drawer: false,
      cascadeData: ['广东', '深圳市'],
      schoolList: [],
      activity_id: 0, // 团 ID
      msg: '',
      drawerSchool: false,
      activeName: '2',
      provinceList: [],
      provinceName: '',
      cityList: [],
      cityName: '',
      districtList: [],
      districtName: '',
      tempSchoolList: [],
      filterSchool: '',
      isCarConfirm: false,
      carPlayBackList: '', // 购物车购买回放列表
      invited_id: 0
    }
  },
  components: {
    EntranceAgreement
  },
  methods: {
    ...mapActions(['getUserInfo']),
    // 获取缓存面授信息
    getCacheOfflineOrder () {
      const params = {
        // class_id: this.classInfo.classId
      }
      api.getCacheOfflineOrder(params).then(r => {
        if (r.data.code === 1) {
          if (r.data.data) {
            this.registerInfo.name = r.data.data.student_name
            this.registerInfo.schoolName = r.data.data.school
            this.registerInfo.grade = r.data.data.grade
            this.registerInfo.parentphone = r.data.data.parent_phone
          }
        } else {
          this.$message.warning(r.data.message)
        }
      })
        .catch(e => {
          console.log(e)
        })
    },
    closeShowDialog () {
      this.drawer = false
      this.centerDialogVisible = false
    },
    showDialog (type = 0, activityId = 0) {
      if (!store.state.user.isLogin) {
        this.goLogin()
        return
      }
      this.activity_type = Number(type) ? Number(type) : 0
      this.activity_id = activityId
      // this.registerInfo.phone = this.userInfo.mobile.toString() // 获取用户手机号
      this.registerInfo.phone = store.state.user.userInfo.mobile.toString() // 获取用户手机号
      // if (this.isLive) {
      //   this.goConfirm('live')
      //   return false
      // }
      if (utils.isMobile()) {
        this.drawer = true
        this.centerDialogVisible = false
      } else {
        this.drawer = false
        this.centerDialogVisible = !this.centerDialogVisible
      }
      this.zhuGeEventTrack(this.zhugeEvents.COURSE_DETAIL.SIGN_UP_CLICK, [this.classInfo.title, this.classInfo.class_id])
    },
    showDialogComfirm (e) {
      this.isCarConfirm = e
      this.registerInfo.phone = store.state.user.userInfo.mobile.toString() // 获取用户手机号
      if (utils.isMobile()) {
        this.drawer = true
        this.centerDialogVisible = false
      } else {
        this.drawer = false
        this.centerDialogVisible = !this.centerDialogVisible
      }
    },
    openedDrawer () {
      $('input').blur()
    },
    initProvince (node, resolve) {
      const { level, path = [] } = node
      const func = ['getProvince', 'getCities', 'getDistricts']
      api[func[path.length]](...path).then(res => {
        const nodes = res.data.map(city => {
          return {
            label: city.name,
            value: city.name,
            leaf: level >= 2
          }
        })
        resolve(nodes)
      })
    },
    initSchool () {
      if (!this.cascadeData || !this.cascadeData.length === 3) return
      api.getSchool(...this.cascadeData).then(res => {
        this.schoolList = res.data.schools
      })
    },
    openSchoolDrawer () {
      this.beforeLeave(0)
      this.provinceName = '广东'
      this.beforeLeave(1)
      this.cityName = '深圳市'
      this.beforeLeave(2)
      this.filterSchool = ''
      this.drawerSchool = true
    },
    filterSchoolName () {
      this.tempSchoolList = this.schoolList.filter(item => {
        return item.school_name.indexOf(this.filterSchool) > -1 || this.filterSchool === ''
      })
    },
    nameClick (index, name) {
      if (index === 0) {
        this.provinceName = name
        this.cityList = []
        this.districtList = []
      } else if (index === 1) {
        this.cityName = name
        this.districtList = []
      } else if (index === 2) {
        this.districtName = name
        this.schoolList = []
      } else if (index === 3) {
        this.registerInfo.schoolName = name
        this.drawerSchool = false
      }
      if (index !== 3) {
        this.beforeLeave(index + 1)
        this.activeName = index + 1 + ''
      }
    },
    beforeLeave (index) {
      if (index === 0) {
        this.loadJsonData(index)
      } else if (index === 1) {
        this.loadJsonData(index, [this.provinceName])
      } else if (index === 2) {
        this.loadJsonData(index, [this.provinceName, this.cityName])
      } else if (index === 3) {
        this.loadJsonData(index, [this.provinceName, this.cityName, this.districtName])
      }
    },
    loadJsonData (index, path = []) {
      const func = ['getProvince', 'getCities', 'getDistricts', 'getSchool']
      this.reqJsonData(func[index], path).then(res => {
        if (index === 0) {
          this.provinceList = this.pySegSort(res.data)
        } else if (index === 1) {
          this.cityList = this.pySegSort(res.data)
        } else if (index === 2) {
          this.districtList = this.pySegSort(res.data)
        } else if (index === 3) {
          this.schoolList = res.data.schools
          this.tempSchoolList = this.schoolList
        }
      })
    },
    async reqJsonData (func, path) {
      return api[func](...path)
    },
    pySegSort (arr) {
      // console.log('data', arr)
      const letters = 'abcdefghjklmnopqrstwxyz'.split('')
      const sorted = []
      letters.forEach(function (el, index) {
        const obj = { letter: '', data: [] }
        arr.forEach(function (str) {
          let firstLetter = pinyin(str.name.substring(0, 1), {
            style: pinyin.STYLE_FIRST_LETTER
          })[0][0].toLowerCase()
          if (str.name.includes('重庆')) {
            firstLetter = 'c'
          }
          if (letters[index].charCodeAt(0) === firstLetter.charCodeAt(0)) {
            obj.data.push(str.name)
            obj.letter = firstLetter.toUpperCase()
          }
        })
        if (obj.data.length) {
          sorted.push(obj)
        }
      })
      return sorted
    },
    querySearch (queryString, cb) {
      const restaurants = this.schoolList
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.school_name.indexOf(queryString) > -1)
      }
    },
    handleSelect (e) {
      this.$set(this.registerInfo, 'schoolName', e.school_name)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const registerInfo = this.registerInfo
          const json = {
            class_id: Number(this.classInfo.classId),
            student_name: registerInfo.name,
            phone: registerInfo.phone,
            school: registerInfo.schoolName,
            grade: registerInfo.grade,
            goods_type: this.classInfo.goodsType,
            goods_id: '0',
            activity_type: 0,
            activity_id: this.classInfo.activityId,
            parent_phone: registerInfo.parentphone
          }
          this.createOrder(json)
          api.cacheOfflineOrder(json).then(r => {
            if (r.data.code === 1) {

            } else {
              this.$message.warning(r.data.message)
            }
          })
            .catch(e => {
              console.log(e)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
      this.zhuGeEventTrack(this.zhugeEvents.COURSE_DETAIL.SIGN_UP_CLICK)
    },
    goConfirm (classtype, activitytype, cid, playback, activityId) {
      const route = {
        name: 'Confirm',
        params: {
          activity_type: activitytype,
          classId: cid,
          class_type: classtype
          // price: this.classInfo.paramsPrice
        },
        query: {}
      }
      if (activityId) {
        // route.params.activityId = g
        route.query = Object.assign({}, route.query, { activityId: activityId })
      }
      if (playback) {
        // route.params.playBackList = playback
        route.query = Object.assign({}, route.query, { playBackList: playback })
      }
      if (window.location.search.substring(1)) {
        route.query = Object.assign({}, route.query, { source: window.location.search.substring(1) })
      }
      // if (this.activity_id) {
      //   route.params.activityId = this.activity_id
      // }
      this.$router.push(route)
    },
    confirmMsg () {
      this.$parent.init()
    },
    goLogin () {
      this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
        this.getUserInfo().then(_ => {
          this.$parent.init()
        })
      })
    },
    showAgreement () {
      this.$refs.EntranceAgreement.showFloating()
    },
    readToPay () {
      this.unPayModalVisible = false
      // this.$router.push({ name: 'MyClass' })
      window.location = '/my-class'
    },
    getItemParams (obj, item) {
      // console.log('item', item)
      let data = {
        goods_id: String(item.goods_id),
        goods_type: item.goods_type,
        activity_type: item.extra.activity_type,
        activity_id: Number(item.extra.activity_id)
      }
      if (this.classInfo.needAddressMap[item.goods_id]) {
        data.address_id = Number(this.classInfo.addressId)
      }
      if (this.classInfo.goodsType === 5) {
        data = Object.assign({}, data, {
          phone: obj.phone,
          grade: obj.grade,
          school: obj.school,
          student_name: obj.student_name,
          parent_phone: obj.parent_phone
        })
      }
      return data
    },
    getConfirmParams (obj, item) {
      let res = {
        goods_id: String(item.goods_id),
        activity_type: Number(this.$route.params.activity_type)
      }
      if (this.classInfo.needAddressMap[item.goods_id]) {
        res.address_id = Number(this.classInfo.addressId)
      }
      if (item.union_id) {
        res.activity_id = Number(item.union_id)
        res.goods_type = item.goods_type
      } else {
        res.activity_id = Number(this.classInfo.activityId)
        res.goods_type = this.classInfo.goodsType
      }
      if (this.classInfo.goodsType === 5) {
        res = Object.assign({}, res, {
          phone: obj.phone,
          grade: obj.grade,
          school: obj.school,
          student_name: obj.student_name,
          parent_phone: obj.parent_phone
        })
      }
      return res
    },
    createOrder (obj) {
      if (this.classInfo.isCarConfirm) {
        this.isCarConfirm = true
      }
      if (this.classInfo.needAddress && !this.classInfo.addressId) {
        this.$message.warning('请选择邮寄地址')
        return false
      }
      const goodsItems = []
      if (this.isCarConfirm) {
        _.each(this.classInfo.classList, item => {
          if (!item.union_id || item.union_id === 0) {
            goodsItems.push(this.getItemParams(obj, item))
          } else {
            _.each(item.union_cart_list, cla => {
              goodsItems.push(this.getItemParams(obj, cla))
            })
          }
        })
      } else {
        this.classInfo.datalist.map(item => {
          goodsItems.push(this.getConfirmParams(obj, item))
        })
      }
      const json = {
        goods_items: goodsItems,
        // from_source: '质心灵动量',
        coupon_id: this.classInfo.couponId
      }
      if (this.$route && this.$route.query.playBackList) {
        json.goods_items[0].offline_replay = 1
      }
      if (this.isCarConfirm && this.carPlayBackList) {
        const checkedIdList = this.carPlayBackList.split(',')
        json.goods_items.forEach(item => {
          if (checkedIdList.indexOf((item.goods_id)) > -1) {
            item.offline_replay = 1
          }
        })
      }
      json.invited_id = this.invited_id
      json.url_param = ''
      if (this.invited_id) {
        json.url_param = window.location.href.split('?')[1]
      }
      if (!this.isCarConfirm) {
        json.from_source = 3
      }
      if (this.$route && this.$route.query.source) {
        const dataOpt = qs.parse(this.$route.query.source)
        const paramJson = {
          url: window.location.href,
          url_param: qs.stringify(Object.assign(dataOpt)),
          utm_source: dataOpt.utm_source || '',
          utm_campaign: dataOpt.utm_campaign || '',
          utm_medium: dataOpt.utm_medium || '',
          utm_term: dataOpt.utm_term || '',
          utm_content: dataOpt.utm_content || ''
        }
        json.param_json = JSON.stringify(paramJson)
      }
      api
        .creatOrder(json)
        .then(r => {
          if (r.data.code === 1) {
            // that.$router.push({ path: '/pay/' + r.data.data.order_no })
            store.dispatch('getCartCount')
            router.push({ name: 'Pay', params: { orderNo: r.data.data.order_no } })
            this.closeShowDialog()
          } else if (r.data.code === 81025) {
            this.unPayModalVisible = true
          } else if (r.data.code === 81011) {
            this.msg = r.data.message
            this.createFailVisible = true
          } else {
            this.$message.warning(r.data.message)
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    }
  },
  computed: {
    ...mapState({
      // isLogin: state => state.user.isLogin,
      // userInfo: state => state.user.userInfo
    }),
    isLive () {
      return Number(this.classInfo.goods_type) === 2 || this.$route.params.classType === 'live'
    }
  },
  watch: {
    drawer: function () {
      this.drawer === true ? $('.banner').css({ 'z-index': 'unset' }) : $('.banner').css({ 'z-index': '9999' })
    }
  }
  // created () {
  //   this.$nextTick(() => {
  //     this.getCacheOfflineOrder()
  //   })
  // }
}
</script>
<style lang="scss">
#join-in-new {
  .join-in-modal {
    max-width: 600px;
    width: 90%;
    .el-dialog__body {
      padding: 25px 40px 25px;
    }
    .cascade {
      width: 100%;
    }
    .dialog-title {
      font-size: 22px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      letter-spacing: 2px;
    }
    .modal-container {
      width: 100%;
      height: auto;
      .info {
        font-size: 14px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        .title {
          height: 30px;
          span {
            font-size: 12px;
            margin-left: 12px;
            color: #33333360;
          }
        }
        .input {
          margin-top: 8px;
          .el-select {
            width: 100%;
          }
          .el-autocomplete {
            width: 100%;
          }
        }
        .school {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .input {
            width: 70%;
          }
          .sclool-selector {
            width: 90px;
            height: 40px;
            background: linear-gradient(
              308deg,
              rgba(56, 211, 205, 1) 0%,
              rgba(0, 199, 191, 1) 100%
            );
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  .modal-container {
    .protocol {
      font-size: 14px;
      font-weight: 400;
      color: rgba(64, 139, 241, 1);
    }
    .tips {
      margin-left: 23px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }

  .default-input .el-input-group__append {
    color: #fff;
    background-color: #00c7bf;
    border: 1px solid #00c7bf;
  }
}
@media screen and (max-width: 500px) {
  .el-drawer__body .title {
    font-weight: 500;
  }
  .small-popper .el-cascader-menu {
    width: 120px;
    min-width: 120px;
  }
  .small-popper .el-cascader-node {
    padding: 0 10px 0 6px;
  }
  .small-popper .el-cascader-node__prefix {
    left: 2px;
  }
  .small-popper .el-autocomplete-suggestion li {
    font-size: 12px;
    padding: 0 12px;
  }
}

#el-drawer__title {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 0;
  span {
    &:focus {
      outline: none;
    }
  }
  &:focus {
    outline: none;
  }
}
.el-drawer {
  &:focus {
    outline: none;
  }
}

.joinuptabs {
  .el-tabs__nav {
    text-align: center;
    float: none;
  }
  .el-tabs__item {
    width: 33%;
  }
  #tab-school {
    display: none;
  }
  .el-tabs__content {
    padding: 10px 15px;
    margin-top: -15px;
    background: #fbfcfc;
  }
  .el-tab-pane {
    max-height: 300px;
    min-height: 200px;
    overflow: scroll;
    ul {
      padding: 0;
      margin: 0;
      position: relative;
      span {
        position: absolute;
        top: 8px;
        color: #979dac;
      }
      li {
        padding: 6px 0 6px 21px;
        list-style: none;
        color: #333;
        &.active {
          color: #00c7bf;
        }
      }
    }
  }
}

.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
